module.exports = __webpack_public_path__ + "940d1c8bd7d5c161c5272b1bde5019ea.svg";